import React, { useRef, useState, useEffect } from "react";
import Navbar from "../../components/Navbar/Navbar";
import "./Splash.css";
// import SignUp from "../../components/SignUp/SignUp";
// import Bulletbar from "../../components/Navbar/Bulletbar";
// import Footer from "../../components/Footer/Footer";
import { Brandmark } from "../../components/Logo/Logo";
import Login from "../../components/Login/Login";
import SignUp from "../../components/SignUp/SignUp";
import Footer from "../../components/Footer/Footer";

export default function Splash() {
  const wrapper = useRef();

  const [sections, setSections] = useState([]);

  const container = document.querySelector(".scroll-area");

  useEffect(() => {
    if (!container) return;

    container.addEventListener("click", (event) => {
      // Check if the actual clicked item matches what you care about
      if (event.target.matches(".scroll-btn")) {
        console.log("Clicked a section via delegation!", event.target);
      }
    });
  }, [container]);

  useEffect(() => {
    setSections(Array.from(document.querySelectorAll("span")));
  }, []);

  return (
    <>
      <Brandmark width={"300px"} margin={"5vh 0 0"} align={"center"} />

      <Login />
      
      <div className="splash-wrapper" ref={wrapper}>

        <span style={{display: "grid", gridTemplateColumns: "2fr 1fr"}}>
          <img src="" alt="placeholder" />
          <h1>"EXPOSITION IS NOT PERMISSION."</h1>
        </span>

        <span style={{display: "grid", gridTemplateRows: "1fr 1fr max-content"}}>
          <h2>
            Your portfolio was built to be discovered by people. Not harvested
            by automated systems.
            Protect your artwork from AI scraping and automated extraction.
          </h2>

          <SignUp />

          <Footer />
        </span>
        

      </div>
    </>
  );
}

